<template>
  <div class="my-3">

    <h6 class="col my-1 text-center">
      <strong>Tabla de Terapias de la atención</strong>
    </h6>

    <b-row>

      <b-col v-if="terapiasList.length > 0">
        <b-table 
          :items="terapiasList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          
   
          <template #cell(sesiones)="data">
            <b-button
              variant="primary"
              size="sm"
              style="cursor: pointer"
              @click="onShowSesiones(data.item.token)"
            >
              <font-awesome-icon
                icon="magnifying-glass"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>


    <FormSesionesTerapia :onlyView="soloVista"/>

  </div>
</template>

<script>
import FormSesionesTerapia from '../FormSesionesTerapia.vue';

export default {
  name: "TerapiasList",

  components: {
  FormSesionesTerapia
},

  

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      terapiasList: this.value,
      soloVista:true,
    }
  },

  methods: {
    onShowSesiones(tokenTerapia) {
      this.navigateToQuery("sessions", tokenTerapia);
    },
     navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  },

  computed: {
    tableFields(){
      const baseFields = [
      
        { 
          key: "terapia.nombre", 
          label: "Terapia", 
          thClass: "text-center" 
        },
        { 
          key: "cantidad", 
          label: "Cantidad",    
          thClass: "text-center" 
        },
        { 
          key: "numeroOrdenAs400",  
          label: "# Orden As400",  
          thClass: "text-center",
        },

        { 
          key: "motivoSolicitud",  
          label: "Motivo",  
          thClass: "text-center",
        },
        { 
          key: "resumenClinico",  
          label: "Resumen Clinico",  
          thClass: "text-center",
        },
        { 
          key: "resumenClinico",  
          label: "Resumen Clinico",  
          thClass: "text-center",
        },
         { 
          key: "sesiones",  
          label: "Detalles Sesiones",  
          thClass: "text-center",
        },
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  }

}
</script>
